/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
//import AWS from 'aws-sdk';

export default class Uploader {
    constructor() {
        this._queueSize = 1
        this._partsPerFile = 4
        this._current = []
        this._pending = []
        this._bucket = 'soccer-app1.traceup.com'
        this._progress = {}
        this._started = {}
    }

    get queueSize() {
        return this._queueSize
    }

    set queueSize(val) {
        this._queueSize = val
    }

    get bucket() {
        return this._bucket
    }

    set bucket(val) {
        this._bucket = val
    }

    setup() {
        console.log('Uploader.setup')

        //var key = 'AKIAJTQCLQDBXQH2FLEA'
        //var secret = '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'
        /*
        var credentials = new AWS.Credentials({
            accessKeyId: key, secretAccessKey: secret
        });
        AWS.config.credentials = credentials;
        this.s3 = new AWS.S3({
            apiVersion: '2006-03-01',
            maxRetries: 6,
            retryDelayOptions: {
                base: 1000
            },
            httpOptions: {
                timeout: 450000
            }
        });
        */
    }

    getAwsId() {
        console.log('Uploader.getAwsId')
        return new Promise((resolve, reject) => {
            fetch('https://soccer.traceup.com/upload/video/api/aws-identity-id')
                .then((res) => {
                    return res.json()
                })
                .then((json) => {
                    var id = json.data.data
                    resolve(id)
                })
                .catch((err) => {
                    console.log('error:', err)
                    resolve(null)
                })
        })
    }

    upload(file, to, callback) {
        var params = {
            Bucket: this._bucket,
            Key: to,
            Body: file,
            Metadata: { 'name': file.name }
        }
        var upload = this.s3.upload(params)
        var wthis = this
        upload.on('httpUploadProgress', (progress) => {
            if (callback) {
                var now = new Date()
                var started = wthis._started[progress.key]
                var timeUp = (now.getTime() - started) / 1000
                var perSecond = progress.loaded / timeUp
                var timeLeft = (progress.total - progress.loaded) / perSecond
                var percent = Math.floor((progress.loaded / progress.total) * 100) / 100
                callback({
                    key: progress.key,
                    uploaded: percent,
                    success: percent >= 1,
                    timeRemaining: timeLeft
                })
            }
        })
        var ps = upload.minPartSize
        var pc = file.size / ps
        while (pc > upload.maxTotalParts) {
            ps = ps * 1.5
            pc = file.size / ps
        }
        upload.partSize = ps
        upload.queueSize = this._partsPerFile
        upload.progressCallback = callback
        upload.to = to
        this._pending.push(upload)
        this._next()
        return {
            key: to,
            file: file.name,
            uploaded: 0,
            success: null,
            location: null,
            error: null
        }
    }

    _next() {
        if (this._current.length < this._queueSize && this._pending.length > 0) {
            var next = this._pending.splice(0,1)[0]
            this._current.push(next)
            console.log('starting upload')
            const wthis = this
            var now = new Date()
            this._started[next.to] = now.getTime()
            next.send((err, data) => {
                console.log('upload finished', data, err)
                var index = wthis._current.indexOf(next)
                if (wthis._current[index] && wthis._current[index].progressCallback) {
                    wthis._current[index].progressCallback({
                        key: this._current[index].to,
                        error: err,
                        did_complete: true
                    })
                } else {
                    console.log('no progress callback')
                    console.log(wthis._current[index])
                    console.warn('check this please')
                }
                wthis._current.splice(index, 1)
                wthis._next()
            })
        }
    }

    _setPartsPerFile(val) {
        if (this._partsPerFile !== val) {

            this._partsPerFile = val
            let i

            for (i in this._current) {
                this._current[i].queueSize = val
            }

            for (i in this._pending) {
                this._pending[i].queueSize = val
            }

        }
    }

    cancelUpload(key) {
        let upload = null
        let uploadI = -1
        let i = 0

        for (i = 0; i < this._pending.length; i++) {
            let up = this._pending[i]
            if (up.service.config.params.Key === key) {
                uploadI = i
                upload = up
                this._pending.splice(uploadI, 1)
                break
            }
        }

        if (upload === null) {

            for (i = 0; i < this._current.length; i++) {
                let up = this._current[i]
                if (up.service.config.params.Key === key) {
                    uploadI = i
                    upload = up
                    this._current.splice(uploadI, 1)
                    break
                }
            }

        }


        if (upload === null) {
            return false
        } else {
            var params = {
                Bucket: upload.service.config.params.Bucket,
                Key: key,
                UploadId: upload.service.config.params.UploadId
            }
            if (upload.callback != null) {
                upload.abort()
                this.s3.abortMultipartUpload(params, (err, data) => {
                    if (err) {
                        console.log('cancel error', err)
                    } else {
                        console.log('data', data)
                    }
                })
            }

            return true
        }
    }
}
